export default __webpack_public_path__ + "static/media/Ntorq125FI_LateralIzq.35727d2e.webp";